import { JsAudioDevice } from '../../../../../../dualChannel/dualChannelTypes';

export interface BaseSessionWebhookResponse {
  message?: string | null;
  type?: string | null;
}

export interface ReloadWebAppMessage extends BaseSessionWebhookResponse {
  type: null;
  message: 'reload-webapp';
  force: boolean;
}

export interface StartSessionMessage extends BaseSessionWebhookResponse {
  type: null;
  message: 'startSession';
  session: {
    projectId: string;
    cogneedId: string;
  }
}

export interface StopSessionMessage extends BaseSessionWebhookResponse {
  type: null;
  message: 'stopSession';
  externalCallId?: string;
}

export interface OKMessage extends BaseSessionWebhookResponse {
  type: null;
  message: 'OK';
}

export interface DualChannelDevices {
  options: JsAudioDevice[];
  selected?: string;
}

export interface DualChannelDeviceConfig {
  input: DualChannelDevices;
  output: DualChannelDevices;
}

export interface SyncStateUpdateMessage {
  type: 'SyncStateUpdate',
  message: null;
  payload: {
    projectId: string;
    language?: string;
    session?: {
      id: string;
      projectId: string;
      language?: string;
      externalCallId?: string;
    };
    devices?: DualChannelDeviceConfig;
  }
}

export interface ApplicationSyncedMessage extends BaseSessionWebhookResponse {
  type: 'ApplicationSynced',
  message: null;
}

export interface ApplicationUnsyncedMessage extends BaseSessionWebhookResponse {
  type: 'ApplicationUnsynced',
  message: null;
}

export type SessionWebhookResponse = (
  | StartSessionMessage
  | StopSessionMessage
  | OKMessage
  | SyncStateUpdateMessage
  | ApplicationSyncedMessage
  | ApplicationUnsyncedMessage
  | ReloadWebAppMessage
);

export function isStartSessionMessage(message: SessionWebhookResponse): message is StartSessionMessage {
  return message && !message.type && message.message === 'startSession';
}

export function isStopSessionMessage(message: SessionWebhookResponse): message is StopSessionMessage {
  return message && !message.type && message.message === 'stopSession';
}

export function isOKMessage(message: SessionWebhookResponse): message is OKMessage {
  return message && !message.type && message.message === 'OK';
}

export function isSyncStateUpdateMessage(message: SessionWebhookResponse): message is SyncStateUpdateMessage {
  return message && message.type === 'SyncStateUpdate';
}

export function isApplicationSyncedMessage(message: SessionWebhookResponse): message is ApplicationSyncedMessage {
  return message && message.type === 'ApplicationSynced';
}

export function isApplicationUnsyncedMessage(message: SessionWebhookResponse): message is ApplicationUnsyncedMessage {
  return message && message.type === 'ApplicationUnsynced';
}

export function isReloadWebAppMessage(message: SessionWebhookResponse): message is ReloadWebAppMessage {
  return message && !message.type && message.message === 'reload-webapp';
}

export function isSessionWebhookResponse(message: any): message is SessionWebhookResponse {
  return isReloadWebAppMessage(message)
    || isStartSessionMessage(message)
    || isStopSessionMessage(message)
    || isOKMessage(message)
    || isSyncStateUpdateMessage(message)
    || isApplicationSyncedMessage(message)
    || isApplicationUnsyncedMessage(message)
    || isReloadWebAppMessage(message);
}
